<template>
  <div>
    <div class="header-sticky">
      <Header />
    </div>
    <div class="main-container">
      <div class="left-container">
        <span class="left-container-header">Your Circles</span>
        <div
          :class="this.$route.path === '/searchpage/default/all' || this.$route.path === '/searchpage/default' ? 'left-container-choices-active' : 'left-container-choices'"
          @click="handleDiscoverClick"
        >
          <font-awesome-icon v-if="this.$route.path === '/searchpage/default/all'" size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fas', 'search']" />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'search']" />
          Discover New Circle
        </div>
        <div
          :class="
            this.$route.path === '/searchpage/unauthcircle'
              ? 'left-container-choices-active'
              : this.$route.path === '/searchpage/joinedcircle'
              ? 'left-container-choices-active'
              : 'left-container-choices'
          "
          @click="handleJoinedClick"
        >
          <font-awesome-icon
            v-if="this.$route.path === '/searchpage/unauthcircle' || this.$route.path === '/searchpage/joinedcircle'"
            size="lg"
            :style="{ transform: 'scale(1.2)' }"
            :icon="['fas', 'window-maximize']"
          />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'window-maximize']" />
          Circles i’ve joined
        </div>
        <div
          v-if="authUser"
          :class="this.$route.path === '/searchpage/settings' ? 'left-container-choices-active' : 'left-container-choices'"
          @click="handleSettingsClick"
        >
          <font-awesome-icon v-if="this.$route.path === '/searchpage/settings'" size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fas', 'cog']" />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'cog']" />
          Settings
        </div>
      </div>
      <div class="left-container-mob">
        <div @click="handleDiscoverClick" :class="this.$route.path === '/searchpage/default/all' ? 'nav-cont-active' : 'nav-cont'">
          <font-awesome-icon v-if="this.$route.path === '/searchpage/default/all'" size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fas', 'search']" />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'search']" />
          <span :class="this.$route.path === '/searchpage/default/all' ? 'mob-font-active' : 'mob-font'">Discover Circle</span>
        </div>
        <div @click="handleJoinedClick" :class="this.$route.path === '/searchpage/unauthcircle' ? 'nav-cont-active' : this.$route.path === '/searchpage/joinedcircle' ? 'nav-cont-active' : 'nav-cont'">
          <font-awesome-icon
            v-if="this.$route.path === '/searchpage/unauthcircle' || this.$route.path === '/searchpage/joinedcircle'"
            size="lg"
            :style="{ transform: 'scale(1.2)' }"
            :icon="['fas', 'window-maximize']"
          />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'window-maximize']" />
          <div :class="this.$route.path === '/searchpage/unauthcircle' ? 'mob-font-active' : this.$route.path === '/searchpage/joinedcircle' ? 'mob-font-active' : 'mob-font'">Circles i’ve joined</div>
        </div>
        <div v-if="authUser" @click="handleSettingsClick" :class="this.$route.path === '/searchpage/settings' ? 'nav-cont-active' : 'nav-cont'">
          <font-awesome-icon v-if="this.$route.path === '/searchpage/settings'" size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fas', 'cog']" />
          <font-awesome-icon v-else size="lg" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'cog']" />
          <span :class="this.$route.path === '/searchpage/settings' ? 'mob-font-active' : 'mob-font'">Settings</span>
        </div>
      </div>
      <div class="right-container">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.noshow {
  display: none;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.show {
  display: flex;
}
.nav-cont {
  @media only screen and (max-width: 710px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 6px;
    width: 86px;
    height: 40px;
  }
}

.nav-cont-active {
  @media only screen and (max-width: 710px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 6px;
    width: 86px;
    height: 40px;
    color: #2a71d4;
  }
}
.mob-font {
  @media only screen and (max-width: 710px) {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    text-transform: capitalize;
    color: #0f1734;
  }
}

.mob-font-active {
  @media only screen and (max-width: 710px) {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    text-transform: capitalize;
    color: #2a71d4;
  }
}

.left-container-mob {
  display: none;
  @media only screen and (max-width: 710px) {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 16px 8px;
    // gap: 106px;
    width: 100%;
    height: 72px;
    background: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
}

.main-container {
  @media only screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0px;
    margin: 0px;
  }
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 20px;
  padding-bottom: 130px;
  @media only screen and (min-width: 961px) {
    min-height: 100vh;
  }
}

.left-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px 24px;
  gap: 16px;
  max-width: 382px;
  width: 100%;
  //max-height: 198px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  @media only screen and (max-width: 710px) {
    display: none;
  }
}

.left-container-header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}

.left-container-choices-active {
  background: #f1f5f9;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 16px;
  width: 100%;
  height: 40px;
  color: #2a71d4;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}

.left-container-choices:hover {
  background: #f1f5f9;
  cursor: pointer;
}

.left-container-choices {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 16px;
  width: 100%;
  height: 40px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #0f1734;
}

.right-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  max-width: 792px;
  width: 100%;
}

.header-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faWindowMaximize } from "@fortawesome/pro-solid-svg-icons"
import { faSearch } from "@fortawesome/pro-solid-svg-icons"
import { faCog } from "@fortawesome/free-solid-svg-icons";
import Header from "../HeaderGeneric.vue"
import Footer from "../Footer.vue"

library.add(faWindowMaximize)
library.add(faSearch)
library.add(faCog);

export default {
  name: "SearchPage",
  components: { Header, Footer },
  methods: {
    handleDiscoverClick() {
      this.$router.push({
        name: "CirclesAll",
      })
    },

    handleJoinedClick() {
      this.$router.push({
        name: "JoinedCircle",
      })
    },

    handleSettingsClick() {
      this.$router.push({
        name: "Settings",
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/App/circle/SearchPage.vue